"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animationComplete = exports.ANIMATION_COMPLETE = void 0;
exports.ANIMATION_COMPLETE = 'ANIMATION_COMPLETE';
function animationComplete(animationId) {
    return { type: exports.ANIMATION_COMPLETE, animationId: animationId };
}
exports.animationComplete = animationComplete;
